// material-ui
import { createTheme } from '@mui/material/styles';

// project import
import ThemeOption from './theme';

// ==============================|| DEFAULT THEME - PALETTE - MODERN ||============================== //

export default function Palette(mode) {
  const paletteColor = ThemeOption();
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000000',
        white: '#FFFFFF'
      },
      ...paletteColor,
      text: {
        primary: isDark ? '#F4F7F7' : paletteColor.grey[900],
        secondary: isDark ? '#CAD2D3' : paletteColor.grey[700],
        disabled: isDark ? '#7F8C8D' : paletteColor.grey[500]
      },
      action: {
        disabled: isDark ? 'rgba(236, 240, 241, 0.28)' : paletteColor.grey[300],
        hover: isDark ? 'rgba(236, 240, 241, 0.08)' : 'rgba(44, 62, 80, 0.04)'
      },
      divider: isDark ? 'rgba(236, 240, 241, 0.12)' : paletteColor.grey[200],
      background: {
        paper: isDark ? '#16202A' : paletteColor.grey[0],
        default: isDark ? '#101820' : paletteColor.grey[50]
      }
    }
  });
}
